module.exports = __webpack_public_path__ + "static/media/bgr-news-block001.b2655240.svg";